(function(){
  "use strict";
  var PENDANT = (window.TE_PENDANT_URL || "");
  var w = document.getElementById('teWidget'); if(!w) return;
  var stage = 0;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Perf: pause always-on ambient animations while the widget is scrolled out of view.
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function(es){ w.classList.toggle('te-offscreen', !es[0].isIntersecting); }, { rootMargin: '150px' }).observe(w);
  }

  var tint = document.getElementById('teTint');
  var stepsEl = w.querySelectorAll('#teSteps li');
  var panels = w.querySelectorAll('.te-panel');

  var GLYPHS = {
    croc:'<svg viewBox="0 0 24 24" fill="none" stroke="#5a3d18" stroke-width="1.7" stroke-linecap="round"><path d="M6 4 Q7.4 12 6 20 M10 4 Q11.4 12 10 20 M14 4 Q15.4 12 14 20 M18 4 Q19.4 12 18 20"/></svg>',
    silica:'<svg viewBox="0 0 24 24"><path d="M12 3 C12 3 5.5 11 5.5 15.5 A6.5 6.5 0 0 0 18.5 15.5 C18.5 11 12 3 12 3 Z" fill="#5a3d18"/></svg>',
    time:'<svg viewBox="0 0 24 24"><path d="M6 3 H18 V4.4 C18 8.6 13.4 10.6 13.4 12 C13.4 13.4 18 15.4 18 19.6 V21 H6 V19.6 C6 15.4 10.6 13.4 10.6 12 C10.6 10.6 6 8.6 6 4.4 Z" fill="#5a3d18"/></svg>',
    eye:'<svg viewBox="0 0 24 24"><path d="M2.5 12 Q12 4.5 21.5 12 Q12 19.5 2.5 12 Z" fill="none" stroke="#5a3d18" stroke-width="1.7"/><ellipse cx="12" cy="12" rx="2.1" ry="5" fill="#5a3d18"/></svg>'
  };
  var TOKENS = ['croc','silica','time','eye'];
  var earned = [false,false,false,false];

  (function(){ var d=document.getElementById('teDust'),n=reduce?0:10,html='';
    for(var i=0;i<n;i++){ var dur=(11+Math.random()*10).toFixed(1),delay=(-Math.random()*12).toFixed(1),x=(Math.random()*100).toFixed(1),s=(2+Math.random()*2).toFixed(1);
      html+='<i style="left:'+x+'%;width:'+s+'px;height:'+s+'px;animation-duration:'+dur+'s;animation-delay:'+delay+'s"></i>'; } d.innerHTML=html; })();
  (function(){ var s=document.getElementById('teSilica'),n=reduce?0:14,html='';
    for(var i=0;i<n;i++){ var dur=(2.2+Math.random()*2).toFixed(2),delay=(-Math.random()*4).toFixed(2),x=(10+Math.random()*80).toFixed(1);
      html+='<i style="left:'+x+'%;animation-duration:'+dur+'s;animation-delay:'+delay+'s"></i>'; } s.innerHTML=html; })();

  var pal = [
    ['rgba(16,28,38,.55)','rgba(22,45,55,.55)','#9fc0cf'],
    ['rgba(19,36,43,.5)','rgba(31,58,63,.5)','#7fc7c9'],
    ['rgba(36,27,21,.5)','rgba(58,42,24,.5)','#d6a651'],
    ['rgba(36,21,9,.5)','rgba(62,36,16,.5)','#e9cd8a']
  ];
  function paint(){ var p=pal[stage]; tint.style.background='linear-gradient(160deg,'+p[0]+','+p[1]+')'; w.style.setProperty('--te-accent',p[2]); }
  function setStage(n){ stage=n;
    panels.forEach(function(pl){ pl.classList.toggle('active',+pl.dataset.panel===n); });
    stepsEl.forEach(function(li){ var s=+li.dataset.step; li.classList.toggle('done',s<n); li.classList.toggle('now',s===n); });
    paint(); if(n===3) updateEye(50);
  }

  function burst(el, count){
    if(reduce) return;
    var wr=w.getBoundingClientRect(), r=el.getBoundingClientRect();
    var cx=r.left-wr.left+r.width/2, cy=r.top-wr.top+r.height/2;
    for(var i=0;i<(count||14);i++){
      var sp=document.createElement('span'); sp.className='te-spark';
      var ang=Math.random()*Math.PI*2, dist=24+Math.random()*46;
      sp.style.left=cx+'px'; sp.style.top=cy+'px';
      sp.style.setProperty('--dx',Math.cos(ang)*dist+'px');
      sp.style.setProperty('--dy',Math.sin(ang)*dist+'px');
      sp.style.width=sp.style.height=(4+Math.random()*4)+'px';
      w.appendChild(sp); (function(node){ setTimeout(function(){ node.remove(); },720); })(sp);
    }
  }
  function awardToken(i){ if(earned[i]) return; earned[i]=true;
    var slot=w.querySelector('.te-slot[data-slot="'+i+'"]');
    slot.querySelector('.te-coinwrap').innerHTML='<div class="te-coin">'+GLYPHS[TOKENS[i]]+'</div>';
    slot.classList.add('filled'); burst(slot,16);
  }

  // evaluate a chosen card (drag-drop or tap or keyboard)
  function evaluate(card, grid, fb, idx, vessel){
    if(card.classList.contains('dim')) return;
    if(card.dataset.correct){
      card.classList.add('right'); burst(card,18);
      if(vessel){ vessel.classList.add('accept'); }
      Array.prototype.forEach.call(grid.children,function(c){ if(c!==card) c.classList.add('dim'); });
      fb.textContent=card.dataset.why; fb.className='te-fb show good';
      awardToken(idx);
      setTimeout(function(){ setStage(idx+1); }, reduce?200:1500);
    } else {
      card.classList.remove('wrong'); void card.offsetWidth; card.classList.add('wrong');
      fb.textContent=card.dataset.why; fb.className='te-fb show';
    }
  }
  function overEl(el,x,y){ var r=el.getBoundingClientRect(); return x>=r.left&&x<=r.right&&y>=r.top&&y<=r.bottom; }

  // card drag (drag into vessel) + tap + keyboard
  function initGrid(idx){
    var grid=w.querySelector('[data-grid="'+idx+'"]');
    var fb=w.querySelector('[data-fb="'+idx+'"]');
    var vessel=w.querySelector('[data-vessel="'+idx+'"]');
    Array.prototype.forEach.call(grid.children, function(card){
      var moved=false, sx=0, sy=0, clone=null, pid=null;
      card.addEventListener('pointerdown', function(e){
        if(card.classList.contains('dim')) return;
        e.preventDefault(); moved=false; sx=e.clientX; sy=e.clientY; pid=e.pointerId;
        try{ card.setPointerCapture(pid); }catch(_){}
      });
      card.addEventListener('pointermove', function(e){
        if(pid!==e.pointerId) return;
        var dx=e.clientX-sx, dy=e.clientY-sy;
        if(!moved && Math.sqrt(dx*dx+dy*dy)>6){
          moved=true; clone=card.cloneNode(true); clone.className='te-dragging';
          clone.style.width=card.offsetWidth+'px'; document.body.appendChild(clone); card.classList.add('te-ghost');
        }
        if(moved && clone){ clone.style.left=e.clientX+'px'; clone.style.top=e.clientY+'px';
          vessel.classList.toggle('hot', overEl(vessel,e.clientX,e.clientY)); }
      });
      card.addEventListener('pointerup', function(e){
        if(pid!==e.pointerId) return; pid=null;
        var onVessel = clone && overEl(vessel,e.clientX,e.clientY);
        if(clone){ clone.remove(); clone=null; }
        card.classList.remove('te-ghost'); vessel.classList.remove('hot');
        if(!moved){ evaluate(card,grid,fb,idx,vessel); return; }   // tap
        if(onVessel){ evaluate(card,grid,fb,idx,vessel); }          // dropped in vessel
      });
      card.addEventListener('pointercancel', function(){ pid=null; if(clone){clone.remove();clone=null;} card.classList.remove('te-ghost'); vessel.classList.remove('hot'); });
      card.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); evaluate(card,grid,fb,idx,vessel); } });
    });
  }
  initGrid(0); initGrid(1);

  // stage 3 aging
  var t=0, TARGET=25000000;
  var yearsEl=document.getElementById('teYears'), fill=document.getElementById('teFill'), ageBtn=document.getElementById('teAge');
  var holding=false, raf=null;
  function fmt(n){ return Math.round(n).toLocaleString('en-US'); }
  function mix(c1,c2,f){ function h(c){return [parseInt(c.substr(1,2),16),parseInt(c.substr(3,2),16),parseInt(c.substr(5,2),16)];}
    var a=h(c1),b=h(c2),r=Math.round(a[0]+(b[0]-a[0])*f),g=Math.round(a[1]+(b[1]-a[1])*f),bl=Math.round(a[2]+(b[2]-a[2])*f);
    return '#'+[r,g,bl].map(function(x){return ('0'+x.toString(16)).slice(-2);}).join(''); }
  function renderAge(){ w.style.setProperty('--te-transform',t.toFixed(3)); fill.style.width=(t*100)+'%'; yearsEl.textContent=fmt(t*TARGET); w.style.setProperty('--te-accent',mix('#7fc7c9','#e9cd8a',t)); }
  function tick(){ if(holding&&t<1){ t=Math.min(1,t+0.012); renderAge(); if(t>=1){ finishAge(); return; } raf=requestAnimationFrame(tick); } }
  function finishAge(){ ageBtn.textContent='Formed'; ageBtn.disabled=true; awardToken(2); setTimeout(function(){ setStage(3); }, reduce?200:800); }
  function start(e){ if(e) e.preventDefault(); holding=true; if(!raf) tick(); }
  function stop(){ holding=false; if(raf){ cancelAnimationFrame(raf); raf=null; } }
  ageBtn.addEventListener('mousedown',start); ageBtn.addEventListener('touchstart',start,{passive:false});
  ['mouseup','mouseleave','touchend','touchcancel'].forEach(function(ev){ ageBtn.addEventListener(ev,stop); });
  ageBtn.addEventListener('click', function(){ if(holding) return; t=Math.min(1,t+0.2); renderAge(); if(t>=1) finishAge(); });

  // stage 4 chatoyancy
  var gem=document.getElementById('teGem'), shell=document.getElementById('teGemShell'), eye=document.getElementById('teEye'), tilt=document.getElementById('teTilt'), found=document.getElementById('teFound');
  function updateEye(pct){ gem.style.setProperty('--te-bx',pct+'%'); var d=Math.abs(pct-50)/50; eye.style.opacity=(1-d*0.55).toFixed(2);
    tilt.value=pct; gem.setAttribute('aria-valuenow',Math.round(pct));
    var centered=Math.abs(pct-50)<6; shell.classList.toggle('centered',centered);
    if(centered && !earned[3]){ awardToken(3); found.classList.add('show'); burst(gem,20); } }
  function fromPointer(e){ var r=gem.getBoundingClientRect(); var x=(e.touches?e.touches[0].clientX:e.clientX)-r.left; updateEye(Math.max(0,Math.min(100,x/r.width*100))); }
  gem.addEventListener('mousemove',fromPointer); gem.addEventListener('touchmove',function(e){ e.preventDefault(); fromPointer(e); },{passive:false});
  tilt.addEventListener('input',function(){ updateEye(+tilt.value); });
  gem.addEventListener('keydown',function(e){ var v=+tilt.value; if(e.key==='ArrowLeft'){ updateEye(Math.max(0,v-5)); e.preventDefault(); } if(e.key==='ArrowRight'){ updateEye(Math.min(100,v+5)); e.preventDefault(); } });

  // ---- generated natural scenes ----
  var SCENES = {
    desert:{ cap:"Ironstone deserts — the banded iron rock where tiger&rsquo;s eye actually forms.", svg:
      '<svg viewBox="0 0 400 244" preserveAspectRatio="xMidYMid slice"><defs><linearGradient id="dsk" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#f2c67e"/><stop offset=".55" stop-color="#e0954e"/><stop offset="1" stop-color="#bb6531"/></linearGradient></defs>'
      +'<rect width="400" height="244" fill="url(#dsk)"/><circle cx="300" cy="64" r="30" fill="#fff0cf" opacity=".92"/>'
      +'<path d="M0,150 H70 V118 H150 V150 H400 V244 H0 Z" fill="#7f3a1c"/><path d="M0,174 H400 V244 H0 Z" fill="#a5542a"/>'
      +'<path d="M0,198 Q200,186 400,198 V244 H0 Z" fill="#c2733a"/>'
      +'<g stroke="#6f2f14" stroke-width="1" opacity=".35"><line x1="0" y1="184" x2="400" y2="184"/><line x1="0" y1="210" x2="400" y2="210"/></g></svg>' },
    cave:{ cap:"Deep caverns, where mineral-rich water once seeped through the stone.", svg:
      '<svg viewBox="0 0 400 244" preserveAspectRatio="xMidYMid slice"><defs><radialGradient id="cgl" cx="50%" cy="40%" r="62%"><stop offset="0" stop-color="#2b354a"/><stop offset="1" stop-color="#0b0912"/></radialGradient></defs>'
      +'<rect width="400" height="244" fill="url(#cgl)"/><polygon points="150,0 250,0 300,244 100,244" fill="#7fa9c4" opacity=".08"/>'
      +'<g fill="#161422"><polygon points="0,0 40,0 18,58"/><polygon points="58,0 94,0 80,42"/><polygon points="300,0 338,0 320,50"/><polygon points="360,0 400,0 384,62"/></g>'
      +'<path d="M0,200 Q200,184 400,200 V244 H0 Z" fill="#120e18"/>'
      +'<g opacity=".92"><polygon points="118,200 130,152 142,200" fill="#3a7c8c"/><polygon points="138,200 148,140 158,200" fill="#4f9bad"/><polygon points="250,200 262,158 274,200" fill="#6b5aa0"/><polygon points="266,200 276,146 286,200" fill="#8a6fc0"/></g>'
      +'<polygon points="182,244 202,200 222,244" fill="#161422"/></svg>' },
    river:{ cap:"River gravels, where tumbled tiger&rsquo;s eye turns up smooth and polished.", svg:
      '<svg viewBox="0 0 400 244" preserveAspectRatio="xMidYMid slice"><defs><linearGradient id="rsk" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#c3e2ef"/><stop offset="1" stop-color="#82b4d1"/></linearGradient><linearGradient id="rwa" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#6fb0cf"/><stop offset="1" stop-color="#3d7d9a"/></linearGradient></defs>'
      +'<rect width="400" height="150" fill="url(#rsk)"/><circle cx="86" cy="48" r="22" fill="#fdfbe8" opacity=".85"/>'
      +'<path d="M0,150 Q120,112 240,140 T400,122 V150 Z" fill="#5f7f5a"/><rect y="150" width="400" height="94" fill="url(#rwa)"/>'
      +'<g stroke="#dff1f7" stroke-width="2" opacity=".5"><line x1="60" y1="178" x2="150" y2="178"/><line x1="210" y1="200" x2="330" y2="200"/></g>'
      +'<g fill="#8a6a4a"><ellipse cx="42" cy="230" rx="20" ry="8"/><ellipse cx="120" cy="236" rx="26" ry="9"/><ellipse cx="330" cy="232" rx="24" ry="9"/></g></svg>' },
    golden:{ cap:"Golden hour on the cliffs — the same warm light your stone catches.", svg:
      '<svg viewBox="0 0 400 244" preserveAspectRatio="xMidYMid slice"><defs><linearGradient id="gsk" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#3b2a5e"/><stop offset=".5" stop-color="#c0567a"/><stop offset="1" stop-color="#f2a85a"/></linearGradient><radialGradient id="gsun" cx="50%" cy="50%" r="50%"><stop offset="0" stop-color="#fff2c8"/><stop offset="1" stop-color="#ffcf7a" stop-opacity="0"/></radialGradient></defs>'
      +'<rect width="400" height="244" fill="url(#gsk)"/><circle cx="200" cy="152" r="72" fill="url(#gsun)"/><circle cx="200" cy="152" r="26" fill="#ffe6a6"/>'
      +'<rect y="170" width="400" height="74" fill="#b76a4e" opacity=".55"/><rect x="188" y="170" width="24" height="74" fill="#ffe6a6" opacity=".5"/>'
      +'<path d="M0,170 L0,112 Q40,152 82,170 Z" fill="#2a1622"/><path d="M400,170 L400,122 Q360,154 320,170 Z" fill="#2a1622"/></svg>' }
  };
  var sceneBg=document.getElementById('teSceneBg'), cap=document.getElementById('teCap');
  function setScene(key){
    var s=SCENES[key]; if(!s) return;
    sceneBg.innerHTML=''; void sceneBg.offsetWidth; sceneBg.innerHTML=s.svg; cap.innerHTML=s.cap;
    w.querySelectorAll('#teChips .te-chip').forEach(function(c){ c.classList.toggle('active', c.dataset.scene===key); });
  }
  w.querySelectorAll('#teChips .te-chip').forEach(function(c){ c.addEventListener('click', function(){ setScene(c.dataset.scene); }); });

  // free-drag the pendant within the canvas
  var canvas=document.getElementById('teCanvas'), pen=document.getElementById('tePendantDrag'), dropHint=document.getElementById('teDropHint');
  (function(){ var id=null, ox=0, oy=0;
    pen.addEventListener('pointerdown', function(e){ e.preventDefault(); id=e.pointerId; try{ pen.setPointerCapture(id); }catch(_){}
      var r=pen.getBoundingClientRect(); ox=e.clientX-r.left; oy=e.clientY-r.top; pen.classList.add('grabbing'); if(dropHint) dropHint.style.opacity='0'; });
    pen.addEventListener('pointermove', function(e){ if(id!==e.pointerId) return;
      var b=canvas.getBoundingClientRect(); var x=e.clientX-b.left-ox, y=e.clientY-b.top-oy;
      x=Math.max(-pen.offsetWidth*0.28, Math.min(b.width-pen.offsetWidth*0.72, x));
      y=Math.max(-pen.offsetHeight*0.15, Math.min(b.height-pen.offsetHeight*0.55, y));
      pen.style.left=x+'px'; pen.style.top=y+'px'; });
    pen.addEventListener('pointerup', function(e){ if(id===e.pointerId){ id=null; pen.classList.remove('grabbing'); } });
    pen.addEventListener('pointercancel', function(){ id=null; pen.classList.remove('grabbing'); });
  })();

  // reveal + habitat wiring
  function showReveal(){
    document.getElementById('teProductImg').src=PENDANT;
    document.getElementById('teGemStage').style.display='none';
    document.getElementById('teHab').style.display='none';
    document.getElementById('teFinal').style.display='block';
  }
  document.getElementById('teReveal').addEventListener('click', function(){ awardToken(3); showReveal(); });
  document.getElementById('teWild').addEventListener('click', function(){
    pen.src=PENDANT; pen.style.left='38%'; pen.style.top='22%'; if(dropHint) dropHint.style.opacity='';
    setScene('desert');
    document.getElementById('teFinal').style.display='none';
    document.getElementById('teHab').style.display='grid';
  });
  document.getElementById('teBack').addEventListener('click', function(){
    document.getElementById('teHab').style.display='none';
    document.getElementById('teFinal').style.display='block';
  });
  document.getElementById('teAgain').addEventListener('click', function(){
    t=0; holding=false; if(raf){ cancelAnimationFrame(raf); raf=null; }
    w.style.setProperty('--te-transform','0'); fill.style.width='0'; yearsEl.textContent='0';
    ageBtn.textContent='Hold to age the stone'; ageBtn.disabled=false;
    earned=[false,false,false,false];
    w.querySelectorAll('.te-slot').forEach(function(s){ s.classList.remove('filled'); s.querySelector('.te-coinwrap').innerHTML=''; });
    w.querySelectorAll('.te-card').forEach(function(c){ c.classList.remove('right','wrong','dim','te-ghost'); });
    w.querySelectorAll('.te-fb').forEach(function(f){ f.className='te-fb'; f.textContent=''; });
    shell.classList.remove('centered'); found.classList.remove('show');
    document.getElementById('teGemStage').style.display='grid';
    document.getElementById('teFinal').style.display='none';
    document.getElementById('teHab').style.display='none';
    setStage(0);
  });

  paint();
})();
